/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

// https://github.com/ljharb/proposal-global
var $export = require('./_export');

$export($export.S, 'System', {global: require('./_global')});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es7.system.global.js
// module id = 708
// module chunks = 76